(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/use-game-engine/assets/javascripts/use-game-engine.js') >= 0) return;  svs.modules.push('/components/racing/use-game-engine/assets/javascripts/use-game-engine.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const getEngine = svs.racing.gameEngine.getEngine;
const {
  useCallback,
  useEffect,
  useState,
  useMemo
} = React;
const raceNoLongerOpen = svs.racing.common.statusUtil.raceNoLongerOpen;
const raceNotYetOpen = svs.racing.common.statusUtil.raceNotYetOpen;
const resultEngine = svs.racing.gameEngine.engines.result;
const middlewares = [svs.racing.gameEngine.middlewares.debug, svs.racing.gameEngine.middlewares.storage, svs.racing.gameEngine.middlewares.errorHandler];
const bindActionCreators = (actionCreators, dispatch) => Object.keys(actionCreators).reduce((boundActions, key) => {
  const action = actionCreators[key];
  boundActions[key] = function () {
    return dispatch(action(...arguments));
  };
  return boundActions;
}, {});
const bindSelectors = (selectors, state) => Object.keys(selectors).reduce((boundSelectors, key) => {
  const selector = selectors[key];
  boundSelectors[key] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return selector(state, ...args);
  };
  return boundSelectors;
}, {});

const useGameEngine = () => {
  const [engine, setEngine] = useState(undefined);
  const [actionStack, setActionStack] = useState([]);
  const [state, setState] = useState(undefined);
  const dispatch = useCallback(action => {
    setActionStack(stack => {
      const newStack = [...stack, action];
      return newStack;
    });
  }, [setActionStack]);
  const resolveAction = useCallback((action, withEngine) => {
    setState(state => {
      const middlewareActions = [];
      const dispatchMiddleware = action => {
        middlewareActions.push(action);
      };
      let middlewareChain = middlewares.map(middleware => middleware(dispatchMiddleware, withEngine));
      middlewareChain = middlewareChain.reduce((previous, current) => function () {
        return previous(current(...arguments));
      })(withEngine.reducer);

      let updatedState = middlewareChain(state, action);
      while (middlewareActions.length > 0) {
        updatedState = middlewareChain(updatedState, middlewareActions.shift());
      }
      return updatedState;
    });
  }, [setState]);
  const initialize = useCallback((gameType, isSystem, race, pixMode) => {
    const isResult = raceNoLongerOpen(race);
    const isNotStarted = raceNotYetOpen(race);
    const newEngine = isResult || isNotStarted ? resultEngine : getEngine(gameType, isSystem, pixMode);
    setEngine(newEngine);
    setActionStack([]);
    resolveAction(newEngine.actions.initialize(race), newEngine);
  }, [resolveAction]);
  const reset = useCallback(() => {
    setEngine(undefined);
    setState(undefined);
    setActionStack([]);
  }, []);
  useEffect(() => {
    if (actionStack.length > 0) {
      for (let i = 0; i < actionStack.length; i++) {
        resolveAction(actionStack[i], engine);
      }
      setActionStack([]);
    }
  }, [actionStack, dispatch, engine, resolveAction]);
  const ret = useMemo(() => _objectSpread(_objectSpread({}, engine), {}, {
    actions: engine ? bindActionCreators(engine.actions, dispatch) : undefined,
    selectors: engine ? bindSelectors(engine.selectors, state) : undefined,
    initialize,
    reset,
    isReady: Boolean(state)
  }), [state, engine, reset, initialize, dispatch]);
  useEffect(() => {
    const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
    if (isSelfService) {
      if (ret.selectors) {
        svs.components.selfserviceCart.getCartInstance().setGameCallback(() => {
          if (ret.selectors.isComplete()) {
            return svs.components.selfserviceCart.constants.GAMECALLBACK_HASCOMPLETEGAME;
          } else if (ret.selectors.hasAnySet()) {
            return svs.components.selfserviceCart.constants.GAMECALLBACK_HASINCOMPLETEGAME;
          }
          return svs.components.selfserviceCart.constants.GAMECALLBACK_NOGAME;
        });
      } else {
        svs.components.selfserviceCart.getCartInstance().setGameCallback(() => svs.components.selfserviceCart.constants.GAMECALLBACK_NOGAME);
      }
      return () => {
        svs.components.selfserviceCart.getCartInstance().setGameCallback(() => svs.components.selfserviceCart.constants.GAMECALLBACK_NOGAME);
      };
    }
  }, [ret.selectors]);
  return ret;
};
svs.racing.useGameEngine = useGameEngine;

 })(window);